import { Divider } from '@sketch-note/design-system/src/components/divider/divider.component';
import {
  MenuItem,
  MenuItemTwo,
} from '@sketch-note/design-system/src/components/menu/menu.component';
import { MenuItemProps } from '@sketch-note/design-system/src/components/menu/types';
import { Avatar } from '@sketchnote/shared-components';
import cn from 'classnames';
import Link from 'next/link';
import * as React from 'react';
import { isAdvUser, isProUser } from 'src/constants/plans';

export interface ProfilePopoverHeaderProps {
  name?: string;
  avatar?: string;
  owner?: string;
  email?: string;
}

export interface ProfilePopoverHeaderPropsTwo {
  email?: string;
  onClickMenuItem?: (menuitem: MenuItemProps, e: React.KeyboardEvent<HTMLDivElement>) => void;
}

export const ProfilePopoverHeader = ({ name, avatar, owner, email }: ProfilePopoverHeaderProps) => {
  return (
    <div className="flex px-12 py-8 ">
      <Avatar
        wrapperClassName="mt-2 my-auto"
        name={name || ''}
        size="sm"
        src={avatar}
        type="photo"
        tooltip={false}
      />

      <div className="ml-8 my-auto">
        <div className="text-sm font-medium text-gray-999">{name}</div>
        {owner ? (
          <div className="text-xs text-gray-500">
            Owner: {owner}
            <div>{email}</div>
          </div>
        ) : (
          <span />
        )}
      </div>
    </div>
  );
};

export const ShowOtherOptions = ({ onClickMenuItem, menuitems }: any): JSX.Element => {
  if (menuitems?.length > 0) {
    return (
      <div className="text-sm leading-20 font-regular pb-8">
        {menuitems?.map((menu) => (
          <MenuItem
            key={menu.value}
            style={{ paddingLeft: '12px', color: '#030712', fontWeight: '400' }}
            className="w-full py-8 flex text-sm"
            onClick={() => onClickMenuItem?.(menu)}
          >
            {menu.icon}
            <span className="align-middle text-sm font-normal ml-8">{menu.label}</span>
          </MenuItem>
        ))}
      </div>
    );
  } else {
    return <div></div>;
  }
};

export const Options = ({ menuItems, onClickMenuItem }: any): JSX.Element => {
  if (menuItems.length > 0) {
    return (
      <div className="py-8">
        {menuItems.map((menu) =>
          menu.href ? (
            <Link href={menu.href} key={menu.value}>
              <a target="_blank">
                <MenuItem
                  isActive={menu.isActive}
                  key={menu.value}
                  style={{ paddingLeft: '12px', color: '#030712', fontWeight: '400' }}
                  className="w-full py-8 flex text-sm "
                  onClick={() => onClickMenuItem?.(menu)}
                >
                  {menu.icon}
                  <span className="align-middle text-sm font-normal ml-8">{menu.label}</span>
                </MenuItem>
              </a>
            </Link>
          ) : (
            <MenuItem
              isActive={menu.isActive}
              key={menu.value}
              style={{ paddingLeft: '12px', color: '#030712', fontWeight: '400' }}
              className="w-full py-8 flex text-sm"
              onClick={() => onClickMenuItem?.(menu)}
            >
              {menu.icon}
              <span className="align-middle text-sm font-normal ml-8">{menu.label}</span>
            </MenuItem>
          )
        )}
      </div>
    );
  } else {
    return <div></div>;
  }
};

export const ShowOrgs = ({
  organisations,
  onClickMenuItem,
  currentOrganisation,
  plan,
}: any): JSX.Element => {
  if (organisations?.length > 0) {
    return (
      <div className="py-8">
        <div className=" text-gray-400 px-12 text-xs pb-1">Switch Organizations</div>
        {organisations.map((organisation, index) => (
          <MenuItem
            isActive={currentOrganisation?.organisationId === organisation?.organisationId}
            key={organisation?.organisationId}
            style={{ borderRadius: '6px' }}
            className={cn({
              'text-sm pl-12 w-full  hover:border-blue-600 border-l-4 border-transparent hover:bg-blue-100':
                true,
              'border-blue-600 border-l-4 bg-blue-100':
                currentOrganisation?.organisationId === organisation?.organisationId,
            })}
            onClick={() => onClickMenuItem?.(organisation)}
          >
            <div className="flex">
              <Avatar
                wrapperClassName="mt-2 my-auto"
                name={organisation?.name || ''}
                size="sm"
                src={organisation?.avatar}
                type="photo"
                tooltip={false}
              />

              <div className="align-middle text-base my-auto ml-8">
                <div className="flex text-black font-medium">
                  <span
                    style={{
                      color:
                        currentOrganisation?.organisationId === organisation.organisationId
                          ? '#1D3CAA'
                          : '#030712',
                    }}
                    className="block overflow-hidden truncate text-sm"
                  >
                    {organisation.name}&nbsp;
                  </span>
                  {/* {organisation?.notificationCount > 0 && (
                  <span className="bg-yellow-700 text-blue-700 flex justify-center rounded-sm h-22 w-22 text-center pt-2 mt-1 text-xs">
                    {organisation.notificationCount}
                  </span>
                )} */}
                </div>
                <div className="flex text-xs text-gray-500" style={{ fontWeight: '400' }}>
                  {organisation?.members?.length} members
                </div>
              </div>
            </div>
          </MenuItem>
        ))}
      </div>
    );
  } else {
    return <div></div>;
  }
};

export const ShowLoggedInInfo = ({
  email,
  name,
  avatar,
}: {
  email?: string;
  name?: string;
  avatar?: string;
}): JSX.Element => {
  return (
    <div className="pt-8 pb-4">
      <div className=" text-gray-400 px-12 text-xs pb-1">Logged in as </div>
      <div className="flex px-12  py-4">
        <Avatar
          wrapperClassName="mt-2 my-auto"
          name={name || ''}
          size="sm"
          src={avatar}
          type="photo"
          tooltip={false}
        />
        <div className="ml-8 text-sm my-auto" style={{ color: '#4B5563' }}>
          {email}
        </div>
      </div>
    </div>
  );
};

export const planType = (plan: string) => {
  return isProUser(plan) ? 'Pro plan' : isAdvUser(plan) ? 'Advanced Plan' : undefined;
};
